export default __webpack_public_path__ + "static/media/commute.7e3c4157.png";